import { render, staticRenderFns } from "./ArticleHeader.vue?vue&type=template&id=62542bb2&scoped=true"
import script from "./ArticleHeader.vue?vue&type=script&lang=js"
export * from "./ArticleHeader.vue?vue&type=script&lang=js"
import style0 from "./ArticleHeader.vue?vue&type=style&index=0&id=62542bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62542bb2",
  null
  
)

export default component.exports